import { render, staticRenderFns } from "./TabForm.vue?vue&type=template&id=09f92ae2&scoped=true&"
import script from "./TabForm.vue?vue&type=script&lang=js&"
export * from "./TabForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f92ae2",
  null
  
)

export default component.exports